module.exports = __webpack_public_path__ + "dash_20_app_assets/img/singlechoiceanswer.ea02aa62.png";